import { useState } from "react";
import { b2bSendResetEmail } from "@/api/b2bAuth";
import { useLocalizedTexts, t } from "@/utils/translations";
import styles from "./B2bLoginPage.module.css";

interface ForgotPasswordFormProps {
  usernameLabel: string;
  onBack: () => void;
}

export function ForgotPasswordForm({
  usernameLabel,
  onBack,
}: ForgotPasswordFormProps) {
  const texts = useLocalizedTexts();
  const [login, setLogin] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    // The backend always answers 204 — whether the account exists is
    // intentionally not revealed, so the confirmation is always neutral.
    await b2bSendResetEmail(login);
    setIsSent(true);
    setIsSubmitting(false);
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      {isSent ? (
        <p className={styles.success}>
          {t(
            texts,
            "Tracker.MyAccountB2b.ResetEmailSent",
            "If an account exists for that username, a password reset email has been sent."
          )}
        </p>
      ) : (
        <>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="b2b-forgot-login">
              {usernameLabel}
            </label>
            <input
              id="b2b-forgot-login"
              className={styles.input}
              type="text"
              autoComplete="username"
              required
              value={login}
              onChange={(e) => setLogin(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className={styles.submitButton}
            disabled={isSubmitting}
          >
            {t(
              texts,
              "Tracker.Generic.SendPasswordResetEmail",
              "Send password reset email"
            )}
          </button>
        </>
      )}
      <button type="button" className={styles.linkButton} onClick={onBack}>
        {t(texts, "Tracker.Generic.Back", "Back")}
      </button>
    </form>
  );
}
